import React from "react";
import { Page } from "../Page";
import { api } from "../../api/api";
import { account_resource, ref } from "../../types";
import { Table } from "../../core/ui/Table";
import { ConditionalController, useConditional } from "../../core/hooks/useConditional";
import { Modal } from "../../core/ui/Modal";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { Text } from "../../core/form/Text";
import { EditableTable } from "../../core/ui/EditableTable";
import { AdvancedFileUpload } from "../../core/form/FileUpload";
import { GenericCol, IDCol, LastUpdatedCol, SizeBytesCol, SyncTableCol, TitleCol, VersionCol } from "../../layout/TableCells";
import { newID } from "../../core/utils/unique";
import { expectArray } from "../../core/utils/array";


// export function EditModal(props: {
// 	item: ref,
// 	controller: ConditionalController<any>,

// 	onSave: () => void,
// 	onDelete: () => void,
// }) {

// 	const data = useDataContext({ initialValue: props.item });

// 	return (
// 		<DataContext.Provider value={data}>
// 			<Modal
// 				title="Edit Reference Table"
// 				onCancel={props.controller.close}
// 				onSave={props.onSave}
// 				saveOnEnterKey={false}
// 				showDelete={true}
// 				onDelete={props.onDelete}
// 			>

// 				<fieldset>
// 					<Text prop="id" title="ID" />
// 					<Text prop="title" title="Title" />
// 				</fieldset>

// 				<EditableTable
// 					data={props.item.data}
// 				/>

// 			</Modal>
// 		</DataContext.Provider>
// 	)

// }


export function UploadModal(props: {
	onCancel: () => void,
	onComplete: () => void,
}) {

	// const data = useDataContext({ initialValue: props.item });

	return (
		// <DataContext.Provider value={data}>
			<Modal
				title="Upload Resource"
				size="width-50vw"
				cancelTitle="Close"
				showSave={false}
				onCancel={props.onCancel}
				onSave={() => {

				}}
				saveOnEnterKey={false}
			>

				<AdvancedFileUpload
					multiple={false}
					onStartUpload={(fileState) => {
						return api.account_resource_upload({
							name: fileState.file.name,
							data: fileState.data,
						});
					}}
					onUploadComplete={(result: any) => {
						
					}}
				/>

			</Modal>
		// </DataContext.Provider>
	)

}


export function Resources(props: {

}) {

	const [resources, setResources] = React.useState<account_resource[]>();

	const [token, setToken] = React.useState("");

	React.useEffect(() => {
		api.account_resource_get({}).then((resources) => {
			const items = expectArray(resources);
			items.sort((a: any, b: any) => {
				return (a ? a.title : "").localeCompare(b ? b.title : "");
			});

			setResources(items);

		}).catch(() => {

		});
	}, [token]);

	// const edit = useConditional((r: ref) => {
	// 	return (
	// 		<EditModal
	// 			item={r}
	// 			controller={edit}

	// 			onSave={() => {
	// 				api.ref_post(r).then((result: any) => {
	// 					if (result.id && !r.id) r.id = result.id;

	// 					edit.close();
	// 				}).catch(() => {

	// 				});
	// 			}}
	// 			onDelete={() => {
	// 				api.ref_delete(r).then((result: any) => {
	// 					if (refs) {
	// 						const items = refs.slice(0);
	// 						for(let i=0;i<items.length;i++) {
	// 							if (items[i] === r) {
	// 								items.splice(i, 1);
	// 								setRefs(items);
	// 								break;
	// 							}
	// 						}	
	// 					}

	// 					edit.close();
	// 				}).catch(() => {

	// 				});
	// 			}}
	// 		/>
	// 	)
	// });

	const upload = useConditional((data) => {
		return (
			<UploadModal
				onCancel={upload.close}
				onComplete={() => {
					upload.close();
				}}
			/>
		)
	});

	if (!resources) {
		return null;
	}
	
	return (
		<Page
			compact={true}
			title={{
				text: "Resources",
				icon: "resources_color",
				buttons: [
					{ title: "Upload" }
				]
			}}
			onButton={(btn) => {
				upload.show({});
			}}
		>

			<Table
				interactive={true}
				cols={[
					VersionCol(),
					TitleCol(),
					GenericCol("Extension", "ext", "align-center"),
					SizeBytesCol(),
					IDCol(),
					LastUpdatedCol(),
					SyncTableCol({ container: "account_resource", onSync: () => {
						setToken(newID());
					} }),
				]}
				items={resources}

				onClick={(e, r) => {
					if (r) {
						//edit.show(r);
					}
				}}
			/>

			{/* {edit.render()} */}
			{upload.render()}

		</Page>
	);
}